import { ChangeDetectorRef, Component } from "@angular/core";
import { FormGroup } from "@angular/forms";
import { ContractService } from "../../../../../auth/service/contract.service";
import { ManageBargainingContractService } from "../../../../../auth/service/manage-bargaining-contract.service";
import { CitiesService } from "../../../../../auth/service/cities.service";
import { AuthenticationService } from "../../../../../auth/service";
import { ActivatedRoute, ParamMap, Router } from "@angular/router";
import { UserFigureService } from "../../../../../auth/service/user-figure.service";
import { UtilsService } from "../../../../../auth/service/utils.service";
import * as moment from "moment";
import { locale as italian } from "../../../../../i18n/it";
import { TransformationService } from "../../../transformation.service";
import { CollaboratorsService } from "../../../collaborators.service";
import { IContentHeader } from "app/layout/components/content-header/content-header.component";

@Component({
  selector: "app-create-transformation",
  templateUrl: "./create-transformation.component.html",
  styleUrls: ["./create-transformation.component.scss"],
})
export class CreateTransformationComponent {
  public contentHeader: IContentHeader;

  public formGroup: FormGroup;

  public currentUser: any;

  public today_date: string;

  public contractList: any = [];

  constructor(
    public _contractService: ContractService,
    public _contractManager: ManageBargainingContractService,
    private _changeDetectorRef: ChangeDetectorRef,
    public _citiesService: CitiesService,
    public _authenticationService: AuthenticationService,
    private _activatedRoute: ActivatedRoute,
    public _userFigureService: UserFigureService,
    public _transformationService: TransformationService,
    public _utilService: UtilsService,
    private _router: Router,
    private _collaboratorService: CollaboratorsService,
  ) {
    this._activatedRoute.paramMap.subscribe(async (params: ParamMap) => {
      const userIdentifier: any = params.get("user_identifier");
      if (!this._authenticationService.hasCapability("create_transformation") && userIdentifier) {
        await this._router.navigateByUrl("/dashboard/main");
        return false;
      }
      if (userIdentifier) {
        this._utilService.disableAutoHideLoading();
        await this.loadUserData(userIdentifier);
      }
    });
    this.today_date = moment().format("YYYY-MM-DD");
  }

  ngOnDestroy() {
    this._contractManager.resetData();
  }

  async transformRal(value: any) {
    await this._contractManager.changeSalaryGrossYearly(this._utilService.fixRal(value));
  }

  async loadUserData(identifier: any) {
    this.currentUser = await this._collaboratorService.getCollaborator(identifier);
    if (!this.currentUser) {
      await this._router.navigateByUrl("/dashboard/main");
      return false;
    } else {
      await this._contractManager.init();

      this._contractManager.data.record_type = "desiderata";

      this._utilService.hideLoading();
      this._changeDetectorRef.detectChanges();
    }
    await this._contractService.getList();
    this.contractList = this._contractService.list;
    //Escludo dai contratti stage e disoccupato che per le trasformazioni non ci occorrono(i collaboratori sono già stagisti)
    this.contractList = this.contractList.filter((contract) => contract.name !== "Stage" && contract.name !== "Disoccupato");

    //Controllo per capire se a un collaboratore si possa offrire un contratto di apprendistato
    this.currentUser.apprenticeship = 100;
    if (this.currentUser && this.currentUser.birthday) {
      this.currentUser.apprenticeship = moment().diff(this.currentUser.birthday, "years");
    }

    if (this.currentUser) {
      const titleForCollaboratorWithName: string = italian.data.CREATE_TRANSFORMATION + " " + italian.data.FOR + " " + this.currentUser.complete_name;
      const titleForCollaboratorWithBusinessName: string = italian.data.CREATE_TRANSFORMATION + " " + italian.data.FOR + " " + this.currentUser.business_name;
      this.contentHeader = {
        headerTitle: this.currentUser.firstname && this.currentUser.lastname ? titleForCollaboratorWithName : titleForCollaboratorWithBusinessName,
        actionButton: false,
        breadcrumb: {
          type: "",
          links: [
            {
              name: "Home",
              isLink: true,
              link: "/",
            },
            {
              name: "MENU.TRANSFORMATION",
              isLink: true,
              link: "/dashboard/transformation-list",
            },
            {
              name: this.currentUser.firstname && this.currentUser.lastname ? titleForCollaboratorWithName : titleForCollaboratorWithBusinessName,
              isLink: false,
            },
          ],
        },
      };

      this._contractManager.data.role = this.currentUser.figure_id;
      if (this.currentUser.apprenticeship < 30) {
        this._contractManager.data.contract = this.contractList.find((contract: any) => contract.name === "Apprendistato").id;
        this._contractManager.typeIsApprendistato = true;
        this._contractManager.contractDuration = 36;
        this._contractManager.getLevels();
      }
    }
  }

  fieldHasErrors(field_name: string): boolean {
    return this.formGroup.controls[field_name].status === "INVALID" && this.formGroup.controls[field_name].touched;
  }

  isDisabledSave() {
    if (this._contractManager.data.contract === 4) {
      //Controllo in caso di contratto a stage
      if (
        this._contractManager.data.role === "" ||
        this._contractManager.data.contract < 1 ||
        this._contractManager.data.net_monthly_12 < 1 ||
        this._contractManager.data.total_daily < 1 ||
        this._contractManager.data.start_date === "" ||
        this._contractManager.data.total_daily_with_bonus < 1 ||
        !this._contractManager.data.tutor_hash ||
        !this._contractManager.data.end_date
      ) {
        return true;
      }
      return false;
    }
    if (
      this._contractManager.data.level === "" ||
      this._contractManager.data.role === "" ||
      this._contractManager.data.contract < 1 ||
      this._contractManager.data.gross_monthly_12 < 1 ||
      this._contractManager.data.trial === "" ||
      this._contractManager.data.net_monthly_12 < 1 ||
      this._contractManager.data.net_monthly_13 < 1 ||
      this._contractManager.data.total_net_monthly_13 < 1 ||
      this._contractManager.data.salary_yearly_gross < 1 ||
      this._contractManager.data.total_daily < 1 ||
      this._contractManager.data.start_date === ""
    ) {
      return true;
    }
    if (this._contractManager.data.contract === 3 && !this._contractManager.data.tutor_hash) {
      return true;
    }
    if (this._contractManager.data.contract !== 1 && !this._contractManager.data.end_date) {
      return true;
    }
    return false;
  }

  async submit() {
    if (!this._authenticationService.hasCapability("create_transformation")) {
      await this._router.navigateByUrl("/dashboard/main");
      return false;
    }
    let data: any = {
      bonus: String(this._contractManager.data.bonus),
      production_bonus: String(this._contractManager.data.production_bonus),
      contract: this._contractManager.data.contract,
      end_date: this._contractManager.data.end_date,
      gross_monthly_12: this._contractManager.data.gross_monthly_12,
      level: this._contractManager.data.level,
      net_monthly_12: this._contractManager.data.net_monthly_12,
      net_monthly_13: this._contractManager.data.net_monthly_13,
      program: this._contractManager.data.program,
      role: this._contractManager.data.role,
      salary_yearly_gross: this._contractManager.data.salary_yearly_gross,
      start_date: this._contractManager.data.start_date,
      ticket_month_number: this._contractManager.data.ticket_month_number,
      ticket_type: this._contractManager.data.ticket_type,
      ticket_value: String(this._contractManager.data.ticket_value),
      total_daily: this._contractManager.data.total_daily,
      total_net_monthly_13: this._contractManager.data.total_net_monthly_13,
      trial: this._contractManager.data.trial,
      tutor_hash: this._contractManager.data.tutor_hash,
      user_hash: this.currentUser.hash,
    };

    if (this._contractManager.data.contract === 4) {
      //Controllo in caso di contratto a stage elimino campi superflui
      data.bonus = null;
      data.production_bonus = null;
      data.gross_monthly_12 = null;
      data.level = null;
      data.net_monthly_13 = null;
      data.salary_yearly_gross = null;
      data.ticket_month_number = null;
      data.ticket_type = null;
      data.ticket_value = null;
      data.total_net_monthly_13 = null;
      data.trial = null;
    }

    if (!data.end_date || data.end_date.length < 1) {
      data.end_date = null;
    }

    if (data.contract !== 1) {
      // if (data.end_date <= moment(data.start_date).add(data.trial, "days").format("YYYY-MM-DD")) {
      //   await this._utilService.showSWALError({ text: "CONTROL_CONTRACT_DATE" });
      //   return false;
      // }
    }

    this._utilService.showLoading();
    await this._transformationService
      .createTransformation(data)
      .then(async (result: any) => {
        this._utilService.hideLoading();
        await this._utilService.showSWALSuccess({ text: "SUCCESS_SEND_TRANSFORMATION" });
        await this._router.navigateByUrl(`/dashboard/transformation-edit/${result.id}`);
      })
      .catch(async (err: any) => {
        this._utilService.hideLoading();
        if (String(err) == "User already in transformation") {
          await this._utilService.showSWALError({ text: "USER_ALREADY_IN_TRANSFORMATION" });
        } else {
          await this._utilService.showSWALError({ text: "ERROR_SEND_TRANSFORMATION" });
        }
      });
  }

  calculateTicketTotalMonth() {
    const ticketValue = this._utilService.removeDotsFromNumber(this._contractManager.data.ticket_value.toString());
    const ticketMonthNumber = this._utilService.removeDotsFromNumber(this._contractManager.data.ticket_month_number.toString());
    return this._utilService.addDotsToNumber(ticketValue * ticketMonthNumber);
  }

  transformTicketValue(target: any) {
    let { value }: any = target;
    if (value.split(",").length > 2) {
      value = value.split(",");
      const decimals: string = value.pop();
      value = value.join(".");
      value += "," + decimals;
    } else if (!value.includes(",")) {
      value += ",00";
    } else {
      value = value.replace(",", ".");
    }

    target.value = value;
    this._contractManager.data.ticket_value = value;
    this._contractManager.updateData();
  }
}
